import React from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Header from "./Components/Header";
import Footer from "./Components/Footer";

// Pages
import About from "./Components/About";
import Home from "./Components/Home";
import ServicesPage from "./Components/ServicesPage"; 
import PersonalService from "./Components/PersonalService"; 
import Commercial from "./Components/Commercial"; 
import Apostillemumbai from "./Components/Apostillemumbai"; 
import Applyonline from "./Components/Applyonline"; 
import Contactus from "./Components/Contactus"; 
import Apostille from "./Components/Apostille"; 
import FAQ from "./Components/FAQ"; 
import Attestationmumbaimaharshtra from "./Components/attestationmumbaimaharshtra"; 
import UsefulLinks from "./Components/UsefulLinks";
import ScrollToTop from "./Components/ScrollToTop.jsx"; 

import Blog from "./Components/Blog";
import BlogDetails from "./Components/BlogDetails";

import DocumentTranslation from "./Components/DocumentTranslation";
import VisaServices from "./Components/VisaServices";
import FloatingButtons from "./Components/FloatingButtons";

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <ScrollToTop />

        {/* Routes */}
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/services/personal" element={<PersonalService />} />
            <Route path="/services/commercial" element={<Commercial />} />
            <Route path="/services/apostillemumbai" element={<Apostillemumbai />} />
            <Route path="/apostille-online" element={<Applyonline />} />
            <Route path="/contact" element={<Contactus />} />
            <Route path="/apostille" element={<Apostille />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/attestationmumbaimaharshtra" element={<Attestationmumbaimaharshtra />} />
            <Route path="/useful-links" element={<UsefulLinks />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogDetails />} />
            <Route path="/services/document-translation" element={<DocumentTranslation />} />
            <Route path="/services/visa-services" element={<VisaServices />} />

          </Routes>
        </main>

        <Footer />
      </div>
       <FloatingButtons />
    </Router>
  );
}

export default App;
